var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("This page was not found.")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Back to Dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }